import styled from 'styled-components';
var PriceLabel = styled.div.withConfig({
  displayName: "PriceLabel",
  componentId: "sc-1h8rj8n-0"
})(["align-items:flex-start;display:flex;"]);
export default PriceLabel;